import { PrivacyFormFields, PrivacyFormRequest, PrivacyFormRequestType } from '../types';
import { IntlShape } from 'react-intl/src/types';
import { usePrivacyFormFieldsConfig } from '../config';
import { typesLang } from '../../../../../@types/shared/types';

const prepareFormData = (
  {
    requestType,
    requestReason,
    firstname,
    lastname,
    street,
    houseNumber,
    houseNumberAddition,
    postalCode,
    city,
    emailKnown,
    emailKnownNotContact,
    emailContact
  }: PrivacyFormFields,
  locale: typesLang
): PrivacyFormRequest => {
  return {
    requestType,
    comments: requestReason,
    initials: firstname,
    lastname,
    postalCode,
    streetAddress: street,
    housenumber: houseNumber,
    housenumberAddition: houseNumberAddition,
    city,
    emailAddress: emailKnown,
    contactEmailAddress: emailKnownNotContact === 'ja' ? emailKnown : emailContact,
    language: locale
  };
};

const getDefaultValues = (intl: IntlShape): PrivacyFormFields => {
  const privacyFormFieldsConfig = usePrivacyFormFieldsConfig(intl);
  return {
    requestType: privacyFormFieldsConfig.requestType.defaultValue as PrivacyFormRequestType,
    requestReason: privacyFormFieldsConfig.requestReason.defaultValue,
    firstname: privacyFormFieldsConfig.firstname.defaultValue,
    lastname: privacyFormFieldsConfig.lastname.defaultValue,
    street: privacyFormFieldsConfig.street.defaultValue,
    houseNumber: privacyFormFieldsConfig.houseNumber.defaultValue,
    houseNumberAddition: privacyFormFieldsConfig.houseNumberAddition.defaultValue,
    postalCode: privacyFormFieldsConfig.postalCode.defaultValue,
    city: privacyFormFieldsConfig.city.defaultValue,
    emailKnown: privacyFormFieldsConfig.emailKnown.defaultValue,
    emailKnownNotContact: privacyFormFieldsConfig.emailKnownNotContact.defaultValue,
    emailContact: privacyFormFieldsConfig.emailContact.defaultValue
  };
};

const getExplainRequestType = (requestType: PrivacyFormRequestType, intl: IntlShape) => {
  switch (requestType) {
    case 'BezwaarMarketingdoeleinden':
      return intl.formatMessage({
        id: 'privacy.form.requestType.explain.bezwaarMarketingdoeleinden',
        defaultMessage:
          'We schrijven jouw e-mailadres uit voor marketingdoeleinden. Als je je uitschrijft voor het ontvangen van commerciële e-mailingen, ontvang je nog wel belangrijke informatie met betrekking tot de actieve hypotheek. Dit is een wettelijke verplichting.'
      });
    case 'InzagePersoonsgegevens':
      return intl.formatMessage(
        {
          id: 'privacy.form.requestType.explain.inzagePersoonsgegevens',
          defaultMessage:
            'Je ontvangt een afschrift van jouw persoonsgegevens die De Hypotheker heeft geregistreerd en wat daarmee gebeurt. Het inzagerecht kun je eenvoudig uitoefenen via jouw {portalLink}.'
        },
        {
          portalLink: `<a href="https://portal.hypotheker.nl/login" target="_blank">${intl.formatMessage(
            {
              id: 'privacy.form.requestType.explain.inzagePersoonsgegevens.portalLink',
              defaultMessage: 'klantportaal'
            }
          )}</a>`
        }
      );
    case 'RectificatiePersoonsgegevens':
      return intl.formatMessage({
        id: 'privacy.form.requestType.explain.rectificatiePersoonsgegevens',
        defaultMessage:
          'Met dit verzoek geef je aan dat jouw gegevens onjuist zijn en/of aangevuld moeten worden als ze onvolledig zijn.'
      });
    case 'Vergetelheid':
      // return 'Als je hier een beroep op doet, worden je persoonsgegevens definitief uit onze systemen verwijderd. Dit is niet mogelijk als je nog een actief product bij ons hebt of wanneer de bewaartermijn nog niet is verlopen. We schrijven je wel uit voor commerciële mailings. Daarnaast nemen we redelijke stappen om andere verwerkers die namens ons de persoonsgegevens verwerken op de hoogte te stellen dat je hebt verzocht om verwijdering van koppelingen naar en kopieën van jouw persoonsgegevens.';
      return intl.formatMessage({
        id: 'privacy.form.requestType.explain.vergetelheid',
        defaultMessage:
          'Als je hier een beroep op doet, worden je persoonsgegevens definitief uit onze systemen verwijderd. Dit is niet mogelijk als je nog een actief product bij ons hebt of wanneer de bewaartermijn nog niet is verlopen. We schrijven je wel uit voor commerciële mailings. Daarnaast nemen we redelijke stappen om andere verwerkers die namens ons de persoonsgegevens verwerken op de hoogte te stellen dat je hebt verzocht om verwijdering van koppelingen naar en kopieën van jouw persoonsgegevens.'
      });

    default:
      return null;
  }
};

export { prepareFormData, getDefaultValues, getExplainRequestType };
